import { Component, HostListener, Input, OnInit, AfterViewInit, OnChanges, OnDestroy, SimpleChange, ViewEncapsulation } from "@angular/core";
import { combineLatest, Subscription, Subject } from "rxjs";
import { environment } from "../../environments/environment";
import { EmitterService } from "../services/emitter.service";
import { UserDetailsService } from "../services/user-details.service";
import { Utility } from "../shared/utility/utility";
import * as _ from 'underscore';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import _PaymentIQCashier, { IPiqCashierConfig } from 'paymentiq-cashier-bootstrapper';

import { language, xSaleInfoForBuumi } from '../shared/utility/config';
import { HostedCashierPaymentsService } from "../services/hosted-cashier-payments.service";
import { Router } from "@angular/router";
import { BannerService } from "../services/banner.service";

import { AjaxService } from "../services/ajax.service";
import { BonusService } from "../app-myaccount/bonuses/services/bonus.service";
import { takeUntil } from "rxjs/operators";


interface PIQObject {
    sessionId: string;
    userId: string;
    merchantId: string;
    method: string;
    ipAddr: string;
    labelId: string;
}



@Component({
    selector: 'app-hosted-cashier',
    templateUrl: './hosted-cashier.component.html',
    styleUrls: ['./hosted-cashier.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class HostedCashierComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    getTokenAjaxSub: Subscription;
    cashierInstance: any;
    isRedirectNewProviderWindow: boolean = false;
    langCode: string;
    isLoading: boolean;
    profileDetails;
    currencyCode: string;
    destroy$: Subject<boolean> = new Subject<boolean>();
    depositMethod = '';
    moonPayCahier = '2';
    hostedCahier = '1';
    siteUrlPath: string = environment.siteUrl;
    webisteCode = environment.website_code;
    mediaPath = environment.mediaPath;
    isPendingDepositeMoonpay = false;
    showPendingNotification = false;
    isMoonPayPending = false;
    buyCryptoIcon = "";
    userCurrencySymbol = "";
    buyCryptoAmount = 0;
    needToShowDepositWIthBankId=false;
    userCountry='';
    buumiRedirectionLink= xSaleInfoForBuumi.encoded;
    userAffId="";


    constructor(
        private userDetailsService: UserDetailsService,
        private paymentService:HostedCashierPaymentsService,
        public utils: Utility,
        private emitterService:EmitterService,
        private router: Router,
        private bannerService:BannerService,
        private ajaxService: AjaxService,
        private bonusService: BonusService,
    ) { 
       
        this.emitterService.updateBuyCryptoPayment$.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
                this.buyCryptoAmount = parseFloat(data);
        })
        this.userCurrencySymbol = this.userDetailsService.getUserCurrencyDetails().symbol
        this.langCode = localStorage.getItem('langCode')
        this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
          this.langCode = langCode;
        })

        this.emitterService.showMoonpayPending$.pipe(takeUntil(this.destroy$)).subscribe(status => {
          this.isPendingDepositeMoonpay = status;
        })
        this.getWindowType();

        if(this.cashierType == 'deposit'){
            this.depositMethod = this.hostedCahier
            this.changePaymentMethode(this.depositMethod);
           
        }else{
            this.changePaymentMethode(this.hostedCahier);
        }
    }

    @Input() cashierType: IPiqCashierConfig["method"]='deposit';
    piqObject: PIQObject = {
        sessionId: '',
        userId: environment.paymentIqUID,
        merchantId: environment.paymentIqMID,
        method: '',
        ipAddr: '',
        labelId: ''
    };
    avialableDepositBonusDetails: any;
    windowType: string;
    selectedBonus: any;
    clearSelectedBonus: boolean = false;
    balanceDetails;
    isCashierIframeLoaded: boolean = false;
    website_code = environment.website_code;
    fontFamilyObj = {
        "BMI" : "Tomorrow",
        "KOI" : "Rubik",
        "FSP" : "Archivo",
        "NPN" : "IBM Plex Sans",
        "HLO" : "Archivo",
        "SLT" : "Chivo",
        "LYS" : "Viga",
        "PSU" : "Signika Negative" ,
        "KRU" : "Karla",
        "SHK" : "Karla",
        "POM" : "Karla",
        "JLA" : "Onest",
        "RLT" : "Poppins",
        "HUR" : "Nunito Sans",
        "TIK" : "Quicksand",
        "PEL" : "Funnel Sans",
    }
    @HostListener('window:resize') onResize() {
        this.getWindowType();
    }

    ngOnInit() {
        this.currencyCode = this.userDetailsService.getUserCurrencyCode();
        this.userCountry = this.userDetailsService.userProfileDetails && this.userDetailsService.userProfileDetails.country ? this.userDetailsService.userProfileDetails.country : "";
        if(this.userCountry){
            this.needToShowDepositWIthBankId = environment.xSaleBuumiCountries.indexOf(this.userCountry) >=0 ? true : false;
            this.userAffId = this.utils.getAffliateId('affiliate');
            if(this.userAffId && this.userAffId != '0' && this.needToShowDepositWIthBankId){
                this.buumiRedirectionLink = xSaleInfoForBuumi.siteNameWithAffId+this.userAffId;
            }
        }
       
        
    }


    ngOnChanges(changes: {
        [propName: string]: SimpleChange
    }) {
        if (changes['cashierType']) {
            this.cashierType = changes['cashierType'].currentValue;
        }
    }
    closePendingCashierModal(){
        this.emitterService.broadcastModalState({ name: "paymentModal", state: "close", cashierType: "deposit" });
        this.emitterService.broadCastShowDepositNotification(true);
        let self = this;
        setTimeout(()=>{
            self.emitterService.broadCastShowDepositNotification(false);
        },5000)
    }
    customCahierIntiation(){
        this.resetValues();
        this.setUpCashier();
        if (this.cashierType === 'deposit') {
            this.getEligibleBonusDetails()
        }
    }

    resetValues(){
        this.isRedirectNewProviderWindow=false
        this.avialableDepositBonusDetails=undefined;
        this.isCashierIframeLoaded=false;
        this.isLoading = false;
        this.selectedBonus=undefined;
        if($('#cashier').contents('iframe').length){
            $('#cashier').empty();
        }  
    }

    closePaymentDepositModal(modalId) {
        this.utils.closeModal(modalId);
        this.emitterService.broadcastdepositInitialisedCall("depositModalClose");

        if(!window.location.pathname.includes('gameplay')){
          this.router.navigate([this.langCode + '/casino/allgames']);
        }else{

          this.router.navigate([], {
            queryParams:
            {
              step: null,
              service: null,
              bonus: null,
              source: null,
              method: null,
              amount: null,
              regstep2: null,
              regstep3: null
            },
            queryParamsHandling: 'merge'
          });
          
        }
      }

     setUpCashier(){
        this.profileDetails = this.userDetailsService.getUserProfileDetails();
        this.isLoading = true;
        this.balanceDetails = this.userDetailsService.getUserBalanceDetails();
        if (!_.isEmpty(this.profileDetails) && !_.isEmpty(this.balanceDetails)) {
            this.piqObject.userId = this.profileDetails.playerID;
            this.getCashierToken();
        } else {
            const getTokenObservable = this.paymentService.getTokenPaymentIQ('cashier');
            const getProfileDataObservable = this.ajaxService.getProfileBalanceCurrency(true);
            combineLatest([getTokenObservable,getProfileDataObservable]).pipe(takeUntil(this.destroy$)).subscribe(([tokenData, profileData]:any)=>{

                if (profileData && profileData.profile && profileData.profile.externalEcrId) {
                    if (profileData.profile.balanceDetails) {
                        this.balanceDetails = profileData.profile.balanceDetails;
                    }
                    this.piqObject.userId = profileData.profile.externalEcrId;
                    this.parseTokenData(tokenData);
                }
            })
            
        }
    }

    getCashierToken() {
        this.paymentService.getTokenPaymentIQ('cashier').pipe(takeUntil(this.destroy$)).subscribe((tokenDetails:any) => {
            if (tokenDetails.status === 'SUCCESS' && tokenDetails.token && tokenDetails.token !== ''){
            this.parseTokenData(tokenDetails);
            }
        });
   }
   changePaymentMethode(paymentMethod){
    if(this.moonPayCahier == paymentMethod){
      this.depositMethod = this.moonPayCahier;
      this.customCahierIntiation();
    }else if(this.hostedCahier == paymentMethod){
      this.depositMethod = this.hostedCahier;
      this.customCahierIntiation();
    }
    this.updateBuycryptoIcon();
 }
 changPaymentMode(paymentmode){
    this.depositMethod = paymentmode;
    this.updateBuycryptoIcon();
 }
 updateBuycryptoIcon(){
    if(this.depositMethod == this.moonPayCahier){
        this.buyCryptoIcon = this.siteUrlPath + '/' + this.mediaPath + '/crypto_logo/hot.png';
    } else{
        this.buyCryptoIcon = this.siteUrlPath + '/' + this.mediaPath + '/crypto_logo/hot_active.png';
    }
 }
    parseTokenData(tokenDetails:any) {
        if (tokenDetails.status === 'SUCCESS' && tokenDetails.token && tokenDetails.token !== '') {
            this.piqObject.sessionId = tokenDetails.token;
            this.piqObject.merchantId = environment.paymentIqMID;
            this.piqObject.ipAddr = tokenDetails.ipAddr;
            this.piqObject.labelId = tokenDetails.labelId;
            this.setupCashier()
        }
    }

    _CHANNEL_ = 'Mac'

    resetCashier() {
        this._CHANNEL_ = 'MAC'
        window['_PaymentIQCashierReset']();
        this.setupCashier()
    }

    resetCashierWithBonus() {
        window['_PaymentIQCashierReset']()
        this._CHANNEL_ = 'Bonus'
        this.setupCashier()
    }

    getChannelId() {
        return this._CHANNEL_
    }

    setupCashier() {
        this.selectedBonus = this.bonusService.getEligibleBonusCode();
        this.cashierInstance = new _PaymentIQCashier('#cashier', {
            merchantId: this.piqObject.merchantId,
            userId: this.piqObject.userId,
            sessionId: this.piqObject.sessionId,
            environment: environment.production ? 'production' : 'test',//production, // if not set, defaults to production
            method: this.cashierType, // if not set, defaults to deposit (deposit or withdrawal),
            locale: language [this.langCode], // Available values: sv_SE, en_US, en_GB, no_NO, fi_FI, pt_BR
            mode: 'gambling', //Set a mode for the cashier (gambling or ecommerce),
            fetchConfig: true,
            font: 'google, ' + this.fontFamilyObj[this.website_code],
            customLogoFileName:'',
            defaultLoader:false,
            gtm:'',
            containerHeight: '100vh',
            // defaultLoader: false, 
            // customLogoFileName: null, 
            // gtm: null
            // enableTermsTemplateFor:false,
            // fixedProviderType:false
            attributes: {
                bonusCode: this.selectedBonus && this.selectedBonus['bonusCode'] ?  this.selectedBonus['bonusCode'] : '',
                labelId: this.piqObject.labelId ? this.piqObject.labelId : environment.website_name,
                productId: "CASINO",
                ipAddr: this.piqObject.ipAddr
            }
        }, (api) => {
            api.on({
                cashierInitLoad: () => {
                    if (document.getElementById('cashier')) {
                        document.getElementById('cashier').style.opacity = '1';
                    }
                    if (document.getElementById('loader')) {
                        document.getElementById('loader').style.opacity = '0'
                    }
                    
                },
                transactionInit: result =>{

                    if(result.data.method === 'deposit'){
                        this.utils.gtmEvent("piq_paySubmit",{
                            'event_type': 'piq_paySubmit',
                            'currency': this.currencyCode,
                            'amount':result.data.amount,
                            'method':result.data.method,
                            'txRefId':result.data.txRefId,
                            'userid': this.userDetailsService.getUserProfileDetails().playerID,
                            'event_context': this.userDetailsService.getUserProfileDetails().userStatus === 'play' ? 'first' : 'subsequent'
                        });
                    }
                },
                update: data => {
                    this.utils.gtmEvent("piq_appLoaded",{
                        'event_type': 'piq_appLoaded',
                        'currency': this.currencyCode,
                        'userid': this.userDetailsService.getUserProfileDetails().playerID,
                        'event_context': this.userDetailsService.getUserProfileDetails().userStatus === 'play' ? 'first' : 'subsequent'
                    });

                    //console.log('The passed in data was set', data)
                },
                success: data => { this.closeCashier('sucess-callback',data)},
                failure: data => { this.closeCashier('failure-callback',data) },
                pending: data => { this.closeCashier('pending-callback',data) },
                unresolved: data => { this.closeCashier('unresolved-callback',data) },
                isLoading: data => console.log('isLoading', data),
                doneLoading: data => {
                    //console.log('Data has been successfully downloaded', data);
                    this.isLoading = false;
                    this.isCashierIframeLoaded = true;
                    
                    this.utils.gtmEvent("piq_payLoaded",{
                        'event_type': 'piq_payLoaded',
                        'currency': this.currencyCode,
                        'userid': this.userDetailsService.getUserProfileDetails().playerID,
                        'event_context': this.userDetailsService.getUserProfileDetails().userStatus === 'play' ? 'first' : 'subsequent'
                    });
                     
                },
                newProviderWindow: data => {
                    this.isRedirectNewProviderWindow = true;
                },
                paymentMethodSelect: data => console.log('Payment method was selected', data),
                paymentMethodPageEntered: data => console.log('New payment method page was opened', data),
                navigate: data => console.log('Path navigation triggered', data)
            });
            api.css(``)

        })
    }

    closeCashier(callingFrom?,responseData?) {

        if (callingFrom === 'sucess-callback') {
                if(this.cashierType === 'withdrawal'){
                    this.emitterService.broadcastModalState({name:"paymentModal",state:"close"});
                    this.emitterService.broadcastModalState({ name: "pendingwithdrawl", state: "open" });
                    setTimeout(()=>{
                        this.emitterService.broadCastWithdrwalSuccessMsg(true);
                    })
                    this.emitterService.broadPendingWithdrawlCount(true);
                }
            if(
                this.cashierType === 'withdrawal' ||
                this.cashierType === 'deposit'
            ){

                if(this.cashierType === 'deposit'){
                    this.utils.S2Scalls(this.profileDetails, "deposit", Number(responseData['data']['payload']['txAmount']).toFixed(2));
                    this.updateGtmEvent(responseData);
                    this.emitterService.broadCastDepositeSuccess(true);
                }
                
                this.bannerService.clearBanners();
                this.emitterService.broadcasttxnComplete("SUCCESS");
            }

            
        }

        if(callingFrom === 'failure-callback'){

            this.updateGtmEvent(responseData);
        }

    }

    closeModal(){

        this.emitterService.broadcastModalState({name:"paymentModal",state:"close"});

        if(this.isMoonPayPending){
            this.emitterService.broadCastShowDepositNotification(true);
        let self = this;
        setTimeout(()=>{
            self.emitterService.broadCastShowDepositNotification(false);
        },5000)
        }

    }

    updateGtmEvent(responseData){       
        if (this.userDetailsService.getUserProfileDetails() && responseData['data']['payload']) {
            this.utils.gtmEvent("piq_depSuccess",{
                'event_type': 'piq_depSuccess',
                'currency': this.currencyCode,
                'txAmount':responseData['data']['payload']['txAmount'],
                'transactioRefId':responseData['data']['payload']['merchantTxId'],
                'userid': this.userDetailsService.getUserProfileDetails().playerID,
                'event_context': this.userDetailsService.getUserProfileDetails().userStatus === 'play' ? 'first' : 'subsequent'
            });
        }

        if(this.userDetailsService.getUserProfileDetails() && responseData['data']['status']==="FAILED"){

            this.utils.gtmEvent("piq_depFail",{
                'event_type': 'piq_depFail ',
                'currency': this.currencyCode,
                'txAmount':responseData['data']['amount'],
                'transactioRefId':responseData['data']['merchantTxId'],
                'userid': this.userDetailsService.getUserProfileDetails().playerID,
                'event_context': this.userDetailsService.getUserProfileDetails().userStatus === 'play' ? 'first' : 'subsequent'
            });
        }
    }

    setBonusAttributes(code) {
        this.cashierInstance.set({
            attributes: {
                bnsCode: code,
                labelId: environment.website_name,
                productId: "CASINO",
                ipAddr: this.piqObject.ipAddr
            }
        });
    }

    setAttributes() {
        this.cashierInstance.set({
            attributes: {
                labelId: environment.website_name,
                productId: "CASINO",
                ipAddr: this.piqObject.ipAddr
            }
        })
    }

    getEligibleBonusDetails() {
        // this.cashierService.getEligibleBonus({ criteriaType: 'DEPOSIT' }).subscribe(data => {
        //     if (data && data['status'] === 'SUCCESS') {
        //         let eligibleBonusDetails = data['eligibleBonusList'];
        //         if (eligibleBonusDetails) {
        //             this.processEligibleBonusDetails(eligibleBonusDetails);
        //         }
        //     }
        // });
    }

    processEligibleBonusDetails(bonusDeatils) {
        this.avialableDepositBonusDetails = _.filter(bonusDeatils, { criteriaType: 'DEPOSIT' });
    }

    getWindowType() {
        const ww = document.body.clientWidth;
        if (ww <= 1024) {
            this.windowType = 'mobile';
        } else {
            this.windowType = 'device';
        }
    }

    ngAfterViewInit() {
        this.utils.openModal('hosted_cashier_modal');
    }
    

    depositeMoonpay(){
        if(this.buyCryptoAmount){
          this.emitterService.broadCastMoonpayClick(true);
          this.isMoonPayPending = true;
        }   
      }
    ngOnDestroy() {
        // if(this.userDetailsService.getUserProfileDetails() &&

        // this.userDetailsService.getUserProfileDetails().userStatus === 'play' ){​​​​
        
        // Promise.resolve(this.paymentService.getProfileBalanceCurrency()).then();
        
        // }​​​​
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
        this.bonusService.broadRefreshEligibleBonus(true); //removing the bonus code details if it is set earlier
    }
    
}
